import * as Yup from 'yup'


/** Dropoff Inbound Receiving schema for Exclusive Seller (no maximum quantity) */
const sellerInboundReceiveDropoffForExclusiveSellerSchema = Yup.object().shape({
  received_quantity: Yup.number()
    .positive('Must be more than 0')
    .required('Required'),
  weight: Yup.number().positive('Must be more than 0').required('Required')
})

export default sellerInboundReceiveDropoffForExclusiveSellerSchema
